<template>
    <div>
        <div>
            <b-nav tabs>
                <b-nav-item router-link to="/accounting/rr-payoff/payment">
                    <icon name="list-alt"></icon>
                    รายการบันทึกจ่าย
                </b-nav-item>&nbsp
                <b-nav-item router-link to="/accounting/rr-payoff/payoff">
                    <icon name="file-invoice"></icon>
                    รายการรอชำระ
                </b-nav-item>&nbsp
                <b-nav-item router-link to="/accounting/rr-payoff/account">
                    <icon name="file-import"></icon>
                    รหัสบัญชี
                </b-nav-item>&nbsp
                <b-nav-item router-link to="/accounting/rr-payoff/cheque">
                    <icon name="money-check"></icon>
                    รายการเช็ค
                </b-nav-item>&nbsp
                <b-nav-item router-link to="/accounting/rr-payoff/mile-seller">
                    <icon name="money-check"></icon>
                    บันทึกไมล์รถเซลล์
                </b-nav-item>&nbsp
                <b-nav-item router-link to="/accounting/rr-payoff/driver-payment-report">
                    <icon name="money-check"></icon>
                    รายงานค่าใช้จ่าย
                </b-nav-item>&nbsp
            </b-nav>
        </div>
        <div class="container-fluid"
             style="background-color: white">
            <router-view />
        </div>
    </div>
</template>

<script>
    export default {
        name: "account-billing-payment-layout",
    }
</script>

<style scoped>

</style>
